import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

const ChatSidebarContext = createContext(null);

export const ChatSidebarProvider = ({
  children,
  defaultOpen = true,
  persistKey, // optional: e.g. "chat_sidebar_open"
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  // Optional persistence
  useEffect(() => {
    if (!persistKey) return;
    const stored = localStorage.getItem(persistKey);
    if (stored === null) return;
    setIsOpen(stored === '1');
  }, [persistKey]);

  useEffect(() => {
    if (!persistKey) return;
    localStorage.setItem(persistKey, isOpen ? '1' : '0');
  }, [persistKey, isOpen]);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen((v) => !v), []);

  const value = useMemo(
    () => ({ isOpen, setIsOpen, open, close, toggle }),
    [isOpen, open, close, toggle],
  );

  return (
    <ChatSidebarContext.Provider value={value}>
      {children}
    </ChatSidebarContext.Provider>
  );
};

export const useChatSidebar = () => {
  const ctx = useContext(ChatSidebarContext);
  if (!ctx) {
    throw new Error(
      'useChatSidebar must be used inside <ChatSidebarProvider />',
    );
  }
  return ctx;
};
